import { render, staticRenderFns } from "./CurrentProductsAvailability.vue?vue&type=template&id=6ebaf5ff"
import script from "./CurrentProductsAvailability.vue?vue&type=script&lang=js"
export * from "./CurrentProductsAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports